import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ProtectedRoute from './components/ProtectedRoute';
import NotesGuard from './components/NotesGuard';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Courses from './pages/Courses';
import Notes from './pages/Notes';
import Gallery from './pages/Gallery';
import Videos from './pages/Videos';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import Login from './pages/Login';
import './index.css';

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<Courses />} />

          {/* Notes — protected by access code gate */}
          <Route path="/notes" element={
            <NotesGuard>
              <Notes />
            </NotesGuard>
          } />

           {/* Hidden secure URL — bypasses gate for direct share */}
          <Route path="/secure-notes-sbs2024" element={<Notes />} />

          <Route path="/gallery" element={<Gallery />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/contact" element={<Contact />} />
          
           {/* Hidden secure routes - not exposed in navigation */}
          <Route path="/admin" element={<Login />} />
<Route path="/open" element={
             <ProtectedRoute>
               <Admin />
             </ProtectedRoute>
           } />
          
          {/* Redirect old routes */}
          <Route path="/sbs-secure-login-2024" element={<Navigate to="/admin" replace />} />
          <Route path="/login" element={<Navigate to="/admin" replace />} />
          
          {/* 404 - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
    </BrowserRouter>
  );
}
